import { CaretDown } from "@phosphor-icons/react"
import { Button, Menu, MenuItem, Popover, Toast } from "@vesatogo/grass-core"
import toast from "react-hot-toast"
import { APIRoutes } from "~/constants/routes"
import { useReceiptSelectorList } from "~/store/receipts-selector-store"
const ReceiptActions = () => {
  const { selected } = useReceiptSelectorList()
  const shareViaWhatsApp = async () => {
    toast.custom(<Toast title="Message will be sent!" />)
    Object.values(selected)?.map(async receipt => {
      const id = receipt?.id
      const url = `https://${
        import.meta.env.VITE_REST_URL
      }/${APIRoutes.downloadTradeReceipt(id)}`

      const token = localStorage.getItem("token")
      const commodity_name = receipt?.commodity?.name
      const name = receipt?.seller?.user?.[0]?.full_name
      const total_amount = receipt?.total_amount
      const total_quantity = receipt?.total_quantity
      const qty_unit = "kg"
      const number = receipt?.seller?.user?.[0]?.number
      const { url: responseUrl } = await fetch(url, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      })
      if (responseUrl) {
        const substring = responseUrl.split("trade/")[1]
        const body = {
          to: number,
          notificationTemplateCodename: "setu-receipt",
          statusCallback: `https://${
            import.meta.env.VITE_REST_URL
          }/rest/trade/status-callback/?receipt_id=${id}`,
          contentVariables: {
            name: name,
            commodity_name: commodity_name,
            total_qty: String(total_quantity),
            total_amount: String(total_amount),
            qty_unit: qty_unit,
            link: substring.replace("/", ""),
          },
        }
        const data = await fetch(
          `https://${
            import.meta.env.VITE_REST_URL
          }/notification/send_whatsapp_msg/`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            method: "POST",
            body: JSON.stringify(body),
          }
        )
      }
    })
  }
  return (
    <Popover
      minimal
      arrow={false}
      className="p-0"
      trigger="click"
      interactive
      animation="fade"
      theme="light-border"
      placement="bottom"
      content={
        <Menu className="max-h-52">
          <MenuItem onClick={shareViaWhatsApp}>Share via WhatsApp</MenuItem>
        </Menu>
      }
    >
      <Button
        className="!bg-gray-300 text-sm leading-5 px-3 py-[6px] h-8 md:text-base md:leading-6 md:px-4 md:py-2 md:h-10"
        intent="none"
        leftIcon={<CaretDown weight="fill" />}
      >
        Action
      </Button>
    </Popover>
  )
}

export default ReceiptActions
